"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  az: {
    code: 'az_AZ',
    alpha: 'abcçdeəfgğhxıijkqlmnoöprsştuüvyz',
    bigAlpha: 'ABCÇDEƏFGĞHXIİJKQLMNOÖPRSŞTUÜVYZ'
  },
  en: {
    code: 'en_US',
    alpha: 'abcdefghijklmnopqrstuvwxyz',
    bigAlpha: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  },
  ru: {
    code: 'ru_RU',
    alpha: 'абвгдеёжзийклмнопрстуфхцчшщъыьэюя',
    bigAlpha: 'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ'
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJheiIsImNvZGUiLCJhbHBoYSIsImJpZ0FscGhhIiwiZW4iLCJydSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYnJhcnkvc3JjLWNsaWVudC9pMThuL2NvbmZpZy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gICAgYXo6IHtcbiAgICAgICAgY29kZTogJ2F6X0FaJyxcbiAgICAgICAgYWxwaGE6ICdhYmPDp2RlyZlmZ8SfaHjEsWlqa3FsbW5vw7ZwcnPFn3R1w7x2eXonLFxuICAgICAgICBiaWdBbHBoYTogJ0FCQ8OHREXGj0ZHxJ5IWEnEsEpLUUxNTk/DllBSU8WeVFXDnFZZWicsXG4gICAgfSxcbiAgICBlbjoge1xuICAgICAgICBjb2RlOiAnZW5fVVMnLFxuICAgICAgICBhbHBoYTogJ2FiY2RlZmdoaWprbG1ub3BxcnN0dXZ3eHl6JyxcbiAgICAgICAgYmlnQWxwaGE6ICdBQkNERUZHSElKS0xNTk9QUVJTVFVWV1hZWicsXG4gICAgfSxcbiAgICBydToge1xuICAgICAgICBjb2RlOiAncnVfUlUnLFxuICAgICAgICBhbHBoYTogJ9Cw0LHQstCz0LTQtdGR0LbQt9C40LnQutC70LzQvdC+0L/RgNGB0YLRg9GE0YXRhtGH0YjRidGK0YvRjNGN0Y7RjycsXG4gICAgICAgIGJpZ0FscGhhOiAn0JDQkdCS0JPQlNCV0IHQltCX0JjQmdCa0JvQnNCd0J7Qn9Cg0KHQotCj0KTQpdCm0KfQqNCp0KrQq9Cs0K3QrtCvJyxcbiAgICB9XG59O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7b0NBQWU7RUFDWEEsRUFBRSxFQUFFO0lBQ0FDLElBQUksRUFBRSxPQUFPO0lBQ2JDLEtBQUssRUFBRSxrQ0FBa0M7SUFDekNDLFFBQVEsRUFBRTtFQUNkLENBQUM7RUFDREMsRUFBRSxFQUFFO0lBQ0FILElBQUksRUFBRSxPQUFPO0lBQ2JDLEtBQUssRUFBRSw0QkFBNEI7SUFDbkNDLFFBQVEsRUFBRTtFQUNkLENBQUM7RUFDREUsRUFBRSxFQUFFO0lBQ0FKLElBQUksRUFBRSxPQUFPO0lBQ2JDLEtBQUssRUFBRSxtQ0FBbUM7SUFDMUNDLFFBQVEsRUFBRTtFQUNkO0FBQ0osQ0FBQyIsImlnbm9yZUxpc3QiOltdfQ==